import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PreferredCategories } from '../../model/portfolio-preferences.model';
import { Preferences } from '../../model/preferences.model';
import { MatRadioChange } from '@angular/material';
import { AttributeCode, InvestmentPreference } from '../../model/finzy-flex/user-attribute.model';
import { cloneDeep, find, forEach, remove } from 'lodash';

@Component({
  selector: 'app-max-loan-amount-selector',
  templateUrl: './max-loan-amount-selector.component.html',
  styleUrls: ['./max-loan-amount-selector.component.scss']
})
export class MaxLoanAmountSelectorComponent implements OnInit {
  public maxAmountOptions: number[] = [1, 2, 5, 10];
  public maxAmountSelected: number;

  @Input()
  public readonly investmentPreferences: InvestmentPreference[];

  @Output()
  public readonly preferredInvestmentPreferencesChange = new EventEmitter<InvestmentPreference[]>();

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.getMaxLoanAmountPercentage();
  }

  public getMaxLoanAmountPercentage() {
    const investmentPreference: InvestmentPreference = this.getPreferredMaxLoanAllocationAmountPercentage();
    if (investmentPreference) {
      this.maxAmountSelected = parseInt(investmentPreference.attributeValue);
    } else {
      this.maxAmountSelected = 10;
const selectedInvestmentPreference: InvestmentPreference = {
        attributeCode: AttributeCode.PRO_PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE,
        attributeValue: this.maxAmountSelected
      };
      this.investmentPreferences.push(cloneDeep(selectedInvestmentPreference));
    }
  }

  public setCustomPortfolioPreference(value: number, data: MatRadioChange): void {
    console.log(value, data.source);
this.updateInvestmentPreference(value);
    if (value && this.getPreferredMaxLoanAllocationAmountPercentage()) {
      this.updateInvestmentPreference(value);
    }
    this.preferredInvestmentPreferencesChange.emit(this.investmentPreferences);
  }

  public updateInvestmentPreference(value: number) {
    if (value) {
      forEach(this.investmentPreferences, (investmentPreference: InvestmentPreference) => {
        if (investmentPreference.attributeCode === AttributeCode.PRO_PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE) {
          return investmentPreference.attributeValue = value.toString();
        }
      })
    }
  }

  private getPreferredMaxLoanAllocationAmountPercentage(): InvestmentPreference {
    return find(this.investmentPreferences, ['attributeCode', AttributeCode.PRO_PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE]);
  }
}
